import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {TopicModel} from '../../../../../../models/api/topicModel';
import {AppState} from '../../../../../../store/appState';
import {getIntegrationsByType} from '../../../../../../store/data/dataSelectors';
import {InboxesVisualConversationSelection} from '../../../../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ConversationHeaderTopicPill} from './conversationHeaderTopicPill';

/*
 * Props.
 */

interface ConversationHeaderTopicPillContainerProps {
  topic: TopicModel;
  conversationSelection: InboxesVisualConversationSelection;
}

/*
 * Selectors.
 */

function getTopic(_state: AppState, props: ConversationHeaderTopicPillContainerProps) {
  return props.topic;
}

function makeGetTopicType() {
  return createSelector([getTopic, getIntegrationsByType], (topic, integrations) => {
    const integration = integrations[topic.type];
    return integration && integration.topicType;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationHeaderTopicPillContainerProps>()(() => ({
  topicType: makeGetTopicType(),
}));

export const ConversationHeaderTopicPillContainer = connect(mapStateToProps)(ConversationHeaderTopicPill);
